import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Carousel from 'grommet/components/Carousel'

class Slider extends Component {
  constructor (props) {
    super(props)

    this.state = {
      firstImageLoaded: false,
      carouselWidth: 1789
    }

    this._onImageLoad = this._onImageLoad.bind(this)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.carouselWidth !== this.state.carouselWidth) {
      // force a window resize event so the grommet carousel will recalculate
      window.dispatchEvent(new Event('resize'))
    }
  }

  _onImageLoad (e) {
    if (!this.state.firstImageLoaded) {
      const {
        slideControlWidth
      } = this.props

      if (slideControlWidth) {
        const imageWidth = e.target.width

        this.setState({
          firstImageLoaded: true,
          carouselWidth: imageWidth + (slideControlWidth * 2)
        })
      }
    }
  }

  _renderSlides () {
    const {
      slides
    } = this.props

    return slides.map((slide) => {
      if (slide) {
        return (<img key={slide.id} src={slide.image} onLoad={this._onImageLoad} alt='' />)
      } else {
        return null
      }
    })
  }

  render () {
    const {
      carouselWidth
    } = this.state

    return (
      <Carousel style={{ width: carouselWidth }} autoplay={false} infinite={false}>
        {this._renderSlides()}
      </Carousel>
    )
  }
}

Slider.propTypes = {
  slides: PropTypes.array,
  slideControlWidth: PropTypes.number
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider.js